import { SITE_URL, SITE_NAME, OG_IMAGE, EMAILS, PHONE_RAW } from "@/lib/seo";
import {
  LANDING_TITLE as TITLE,
  LANDING_DESCRIPTION as DESCRIPTION,
  LANDING_KEYWORDS,
} from "@/content/siteMeta";

export const LANDING_TITLE = TITLE;
export const LANDING_DESCRIPTION = DESCRIPTION;
export const LANDING_KEYWORDS_META = LANDING_KEYWORDS;

const faqs = [
  {
    q: "How long until I see new patients?",
    a: "Most clients see their first booked appointments from paid channels within 7 to 14 days of go-live. SEO compounds over 60 to 120 days.",
  },
  {
    q: "Do I need a big ad budget to work with Dental Leads Lab?",
    a: "No. Our smallest clients spend around 1,500 dollars a month on ads and still see profitable returns. Show-up rate, offer and speed to lead matter more than budget size.",
  },
  {
    q: "Are you an agency or a contractor?",
    a: "We are a specialist growth team working only with dentists. You get a dedicated strategist, media buyer, designer and developer on your account.",
  },
  {
    q: "What if the marketing does not work?",
    a: "We work in 90-day sprints with KPIs agreed upfront. If we miss them, we keep working at no additional cost until we hit them.",
  },
  {
    q: "What is included in the free strategy call?",
    a: "A local competitor breakdown, a keyword and demand audit, a funnel review and a realistic 90-day forecast for your practice, yours to keep.",
  },
];

export const landingSchema = [
  {
    "@context": "https://schema.org",
    "@type": ["Organization", "ProfessionalService", "LocalBusiness"],
    "@id": `${SITE_URL}/#organization`,
    name: SITE_NAME,
    alternateName: "DLL",
    description:
      "Dental marketing agency helping dental practices get more new patients with paid advertising, local SEO, high-converting websites and reputation systems.",
    url: SITE_URL,
    logo: `${SITE_URL}/favicon-192.png`,
    image: OG_IMAGE,
    email: EMAILS.hello,
    telephone: PHONE_RAW,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Mumbai",
      addressRegion: "Maharashtra",
      addressCountry: "IN",
    },
    areaServed: [
      { "@type": "Country", name: "India" },
      { "@type": "Country", name: "United States" },
      { "@type": "Country", name: "United Kingdom" },
      { "@type": "Country", name: "Australia" },
      { "@type": "Country", name: "United Arab Emirates" },
    ],
    knowsAbout: [
      "Dental Marketing",
      "Google Ads For Dentists",
      "Local SEO For Dentists",
      "Dental Lead Generation",
      "Dental Website Design",
      "Reputation Management",
    ],
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "sales",
        email: EMAILS.hello,
        telephone: PHONE_RAW,
        availableLanguage: ["English", "Hindi"],
      },
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: EMAILS.support,
        availableLanguage: ["English", "Hindi"],
      },
      {
        "@type": "ContactPoint",
        contactType: "billing support",
        email: EMAILS.billing,
      },
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Dental Marketing Services",
      itemListElement: [
        "Google Ads Management",
        "Local SEO",
        "Social Media Advertising",
        "High-Converting Websites",
        "Reputation Management",
        "Patient Acquisition Funnels",
      ].map((name) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name, serviceType: "Dental Marketing" },
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    url: SITE_URL,
    name: SITE_NAME,
    description: LANDING_DESCRIPTION,
    publisher: { "@id": `${SITE_URL}/#organization` },
    inLanguage: "en",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];
